import { combineReducers } from "redux";
import Sellerlogin from "../Containers/Login/Login-slice";
import Product from "../Containers/Product/Product-slice";
import Category from "../Containers/Category/Category-slice";
import Home from "../Containers/Home/Home-slice";
import Dashboard from "../Containers/Dashboard/Dashboard-slice";
import Analytics from "../Containers/Analytics/Analytics-slice";
import Order from "../Containers/Order/Order-slice";
import Account from "../Containers/Accounts/Account-slice";

const rootReducer = combineReducers({
  Sellerlogin,
  Product,
  Category,
  Home,
  Dashboard,
  Analytics,
  Order,
  Account,
});

export default rootReducer;
